// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer-module--SideDrawer--PoNBk","Open":"SideDrawer-module--Open--15FxE","Close":"SideDrawer-module--Close--112id","Logo":"SideDrawer-module--Logo--3IFTZ"};